import URI from 'urijs'

export const BASE_DOMAIN: string = URI(window.location).origin()
